// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="relative z-10 bg-slate-900/70 backdrop-blur-sm text-slate-300 mt-0">
      {/* - Removed 'mt-12' as spacing will be handled by the reveal spacer in HomePage.jsx
        - Changed background to be semi-transparent dark with blur for overlay.
        - Changed text color to be light for readability on a dark/image background.
      */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid md:grid-cols-3 gap-8 text-center md:text-left">
          <div>
            <h5 className="font-bold text-lg text-white mb-3">AI Brahmi</h5>
            <p className="text-sm">
              Your Personalized Hub for AI Intelligence & Advancement.
            </p>
          </div>
          <div>
            <h5 className="font-bold text-lg text-white mb-3">Quick Links</h5>
            <ul className="space-y-1">
              <li><Link to="/about" className="hover:text-accent-teal transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-accent-teal transition-colors">Contact</Link></li>
              <li><Link to="/disclaimer" className="hover:text-accent-teal transition-colors">Disclaimer</Link></li>
            </ul>
          </div>
          <div>
            <h5 className="font-bold text-lg text-white mb-3">Resources</h5>
            <ul className="space-y-1">
              <li><a href="https://qubitlyventures.com/en/blog" target="_blank" rel="noopener noreferrer" className="hover:text-accent-teal transition-colors">Articles</a></li>
              <li><a href="https://www.instagram.com/qubitly_edu" target="_blank" rel="noopener noreferrer" className="hover:text-accent-teal transition-colors">Connect</a></li>
              <li><a href="https://qubitlyventures.com/" target="_blank" rel="noopener noreferrer" className="hover:text-accent-teal transition-colors">Qubitly Ventures</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-sm">
          <p>&copy; {currentYear} AI Brahmi. All rights reserved. <span className="font-bold">Created by <a href="https://qubitlyventures.com/en/" target="_blank" rel="noopener noreferrer" className="hover:text-accent-teal transition-colors">Qubitly Ventures</a></span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;